export const buildQueryReducerKey = 'buildQueryReducerKey';
export const buildQuerySetQueryReducerType = 'buildQuerySetQueryReducerType';
export const buildQuerySetIsFormsButtonsEnabledReducerType = 'buildQuerySetIsFormsButtonsEnabledReducerType';
export const buildQuerySetIsClassicLicenseReducerType = 'buildQuerySetIsClassicLicenseReducerType';
export const buildQuerySetDbsReducerType = 'buildQuerySetDbsReducerType';
export const buildQuerySetStructurePreviewReducerType = 'buildQuerySetStructurePreviewReducerType';
export const buildQuerySetPreviewSizeReducerType = 'buildQuerySetPreviewSizeReducerType';
export const buildQuerySetQsFormsReducerType = 'buildQuerySetQsFormsReducerType';
export const buildQueryResetStateReducerType = 'buildQueryResetStateReducerType';
export const buildQuerySetStructureNameReducerType = 'buildQuerySetStructureNameReducerType';
